export default "/static/images/banner-sp-250425.png";
